import React, { useState, useEffect } from "react";
import "./Content.scss";
import FinancialReportTriwulan from "../Components/FinancialReport/FinancialReportTriwulan";
import FinancialReportBulanan from "../Components/FinancialReport/FinancialReportBulanan";
import { useTranslation } from "react-i18next";

function FinancialReportContent() {
  const {t} = useTranslation();
  const pillTab = window.location.hash;
  const [activeTabA, setActiveTabA] = useState("");
  const [activeTabB, setActiveTabB] = useState("");
  useEffect(() => {
    if (pillTab === "" || pillTab === "#triwulan") {
      setActiveTabA("active");
    } else if (pillTab === "#bulanan") {
      setActiveTabB("active");
    }
  }, [activeTabA, activeTabB, pillTab]);
  
  return (
    <div className="financial-report-content">
      <ul className="nav nav-underline mb-3" id="pills-tab" role="tablist">
        <li className="nav-item flex-grow-1" role="presentation">
          <button
            className={`nav-link w-100 ${activeTabA ? "active" : ""}`}
            id="pills-triwulan-tab"
            data-bs-toggle="pill"
            data-bs-target="#triwulan"
            type="button"
            role="tab"
            aria-controls="triwulan"
            aria-selected="true"
          >
            {t("laporan_keuangan_triwulan")}
          </button>
        </li>
        <li className="nav-item flex-grow-1" role="presentation">
          <button
            className={`nav-link w-100 ${activeTabB ? "active" : ""}`}
            id="pills-bulanan-tab"
            data-bs-toggle="pill"
            data-bs-target="#bulanan"
            type="button"
            role="tab"
            aria-controls="bulanan"
            aria-selected="false"
          >
            {t("laporan_keuangan_bulanan")}
          </button>
        </li>
      </ul>
      <div className="tab-content" id="pills-tabContent">
        <div
          className={`tab-pane fade ${activeTabA ? "show active" : ""}`}
          id="triwulan"
          role="tabpanel"
          aria-labelledby="pills-triwulan-tab"
        >
          <FinancialReportTriwulan />
        </div>
        <div
          className={`tab-pane fade ${activeTabB ? "show active" : ""}`}
          id="bulanan"
          role="tabpanel"
          aria-labelledby="pills-bulanan-tab"
        >
          <FinancialReportBulanan />
        </div>
      </div>
    </div>
  );
}

export default FinancialReportContent;
